<div class="w-100">
    <!-- Header Section -->
    <div class="d-flex align-items-center justify-content-between header-section">
        <div class="w-75">
            <div class="piezo-title">{{ piezoName || 'STAND 12' }}</div>
        </div>

        <div class="w-25 d-flex justify-content-end align-items-center action-buttons">

            <div class="asset-status-dot" [ngClass]="isAssetRunning ? 'status-running' : 'status-idle'"
                [matTooltip]="isAssetRunning ? 'Asset Running' : 'Asset Idle'" matTooltipClass="custom-tooltip">
            </div>

            <button *ngIf="piezoPhyImgs.length < 4" class="icon-button" (click)="addImage()"
                matTooltip="Add Physical Image" matTooltipClass="custom-tooltip">
                <mat-icon>add_photo_alternate</mat-icon>
            </button>

            <button class="icon-button" (click)="viewPiezoImages()" matTooltip="View Images"
                matTooltipClass="custom-tooltip">
                <mat-icon>remove_red_eye</mat-icon>
            </button>

            <button class="icon-button" (click)="editPiezo()" matTooltip="Edit Piezo" matTooltipClass="custom-tooltip">
                <mat-icon>edit</mat-icon>
            </button>
        </div>
    </div>

    <!-- Main Piezo Container -->
    <div class="d-flex mt-2">
        <div class="piezo-container flex_8 flex">
            <div class="d-flex justify-content-center flex_9">

                <!-- Piezo Sensor Image -->
                <div class="piezo-image-wrapper">

                    <img [src]="piezoImg || './assets/default-piezo.png'" class="piezo-image" alt="Piezo Diagram" />

                    <!-- Enhanced Sensor Markers -->
                    <div class="sensor-marker" [ngClass]="{
                        'sensor-healthy': sensor.color === '#72ff13',
                        'sensor-warning': sensor.color === '#faa700',
                        'sensor-critical': sensor.color === '#',
                        'sensor-offline': sensor.color === '#99999'
                    }" *ngFor="let sensor of sensors" [ngStyle]="{
                        top: sensor.yPercentage + '%',
                        left: sensor.xPercentage + '%'
                    }" [matTooltip]="showTooltip(sensor)" matTooltipClass="sensor-tooltip"
                        (click)="onSensorClick(sensor)">

                        <!-- Status Indicator Ring -->
                        <div class="sensor-status-ring"></div>

                        <!-- Sensor Content -->
                        <div class="sensor-content">
                            <div class="sensor-label">
                                {{ sensor.sensorDNames }}
                            </div>
                            <div class="sensor-wifi-status">
                                <mat-icon class="wifi-icon"
                                    [class.wifi-connected]="sensor.device_status == 1 || sensor.device_status == 0"
                                    [class.wifi-disconnected]="sensor.device_status == 2">
                                    {{ (sensor.device_status == 1 || sensor.device_status == 0) ? 'wifi' : 'wifi_off' }}
                                </mat-icon>
                            </div>
                        </div>

                        <!-- Pulse Animation for Critical -->
                        <div class="sensor-pulse" *ngIf="sensor.color === '#ff2a1b'"></div>
                    </div>
                </div>
            </div>
            <div class="physical-images-column flex_1">
                <div class="physical-image-thumbnail" *ngFor="let img of piezoPhyImgs" (click)="showPhysicalImage(img)">
                    <img [src]="img.url" alt="Physical Image" />
                </div>
            </div>
        </div>

        <app-piezo-anomaly-card class="flex_2" />
    </div>
</div>

<app-powertrain-modal [type]="'img_modal'" [subsystem_id]="subsystem_id" *ngIf="add_physical_img_modal" (closePowertrainPhyImgModal)="closeModal($event)"></app-powertrain-modal>

<app-powertrain-modal [type]="'piezo_powertrain_image'" [subsystem_id]="subsystem_id"
*ngIf="show_powertrain_img" (closePowertrainImgModal)="closeModal($event)"></app-powertrain-modal>

<app-powertrain-modal [type]="'piezo_powertrain_phy_image'" [data]="selected_img" *ngIf="show_physical_image"
  (closePowertrainPhyImgModal)="closeModal($event)"></app-powertrain-modal>